import type { MJCFParseResult } from "../core/mjcfParser";

export const NO_ROBOT_VISUALS_TOAST_MESSAGE =
  "The robot loaded successfully, but no visuals are present. Use visibility toggles to view other features.";

type BodyWithVisualGeoms = {
  geoms?: Array<{ visualOnly?: boolean }>;
};

export function parsedRobotHasVisuals(
  parsedResult: Pick<MJCFParseResult, "bodies"> | null | undefined
): boolean {
  const bodies = parsedResult?.bodies;
  if (!bodies || typeof bodies !== "object") return false;
  return Object.values(bodies as Record<string, BodyWithVisualGeoms>).some((body) => {
    const geoms = Array.isArray(body?.geoms) ? body.geoms : [];
    return geoms.some((geom) => geom?.visualOnly === true);
  });
}

export function parsedResultLooksLikeRobot(
  parsedResult: Partial<MJCFParseResult> | null | undefined
): boolean {
  if (!parsedResult) return false;
  const joints = Array.isArray(parsedResult.joints) ? parsedResult.joints : [];
  const actuators =
    parsedResult.actuators && typeof parsedResult.actuators === "object"
      ? parsedResult.actuators
      : {};
  return joints.length > 0 || Object.keys(actuators).length > 0;
}

export function shouldShowNoRobotVisualsNotice(
  parsedResult: Partial<MJCFParseResult> | null | undefined,
  options: { requireRobotFeatures?: boolean } = {}
): boolean {
  const bodies = parsedResult?.bodies;
  if (!bodies || typeof bodies !== "object" || Object.keys(bodies).length === 0) return false;
  if (options.requireRobotFeatures !== false && !parsedResultLooksLikeRobot(parsedResult))
    return false;
  return !parsedRobotHasVisuals(parsedResult as Pick<MJCFParseResult, "bodies">);
}

export function showNoRobotVisualsNoticeIfNeeded(
  parsedResult: Partial<MJCFParseResult> | null | undefined,
  options: { requireRobotFeatures?: boolean } = {}
): void {
  if (!shouldShowNoRobotVisualsNotice(parsedResult, options)) return;
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("critter-toast", {
      detail: { message: NO_ROBOT_VISUALS_TOAST_MESSAGE },
    })
  );
}
